import { css } from "@emotion/react";

import { colors } from "@styles";

export const tooltipWrapper = css`
  display: inline-block;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999999;
`;

export const circle = css`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  padding-left: 2px;
  border-radius: 10rem;
  background: ${colors.white};
  color: ${colors.primary};
  box-shadow: 0px 0px 24px 3px rgb(0 0 0 / 35%) !important;
`;

export const icon = css`
  display: block;
  width: 34px;
  height: 34px;
`;
